import { Component, EventEmitter, Input, Output, ViewChild, AfterViewInit } from '@angular/core';
import { NgModel } from '@angular/forms';
import { EmptyKrampShippingAddress, KrampShippingAddress } from '../kramp-shipping-address';

@Component({
  selector: 'app-kramp-shipping-address-form',
  templateUrl: './kramp-shipping-address-form.component.html',
  styleUrls: ['./kramp-shipping-address-form.component.scss'],
})
export class KrampShippingAddressFormComponent implements AfterViewInit {
  @ViewChild('shippingAddressCustomerId') shippingAddressCustomerId!: NgModel;
  @ViewChild('shippingAddressName') shippingAddressName!: NgModel;
  @ViewChild('shippingAddressAddress') shippingAddressAddress!: NgModel;
  @ViewChild('shippingAddressZipCode') shippingAddressZipCode!: NgModel;
  @ViewChild('shippingAddressCity') shippingAddressCity!: NgModel;
  @ViewChild('shippingAddressShipToNo') shippingAddressShipToNo!: NgModel;

  @Input() shippingAddresses!: KrampShippingAddress[];
  @Output() createShippingAddress = new EventEmitter<KrampShippingAddress>();
  @Output() updateShippingAddress = new EventEmitter<KrampShippingAddress>();
  @Output() cancelEdit = new EventEmitter<void>();

  createMode: boolean = true;
  workingShippingAddress: KrampShippingAddress = EmptyKrampShippingAddress();

  private viewInitialized = false;

  ngAfterViewInit() {
    this.viewInitialized = true;
  }

  sendUpdateShippingAddress(shippingAddress: KrampShippingAddress): void {
    this.updateShippingAddress.emit(shippingAddress);
  }

  sendCreateShippingAddress(shippingAddress: KrampShippingAddress): void {
    this.createShippingAddress.emit(shippingAddress);
  }

  editShippingAddress(shippingAddress: KrampShippingAddress): void {
    this.workingShippingAddress = Object.assign({}, shippingAddress);
    this.createMode = false;
  }

  cancel(): void {
    if (!this.createMode) {
      this.cancelEdit.emit();
    }
  }

  resetInputFields(): void {
    this.shippingAddressCustomerId.reset();
    this.shippingAddressName.reset();
    this.shippingAddressAddress.reset();
    this.shippingAddressZipCode.reset();
    this.shippingAddressCity.reset();
    this.shippingAddressShipToNo.reset();
    this.workingShippingAddress = EmptyKrampShippingAddress();
    this.createMode = true;
  }

  isFormValid(): boolean {
    return Boolean(
      this.isCustomerIdValid() &&
        this.shippingAddressName.valid &&
        this.shippingAddressAddress.valid &&
        this.shippingAddressZipCode.valid &&
        this.shippingAddressCity.valid &&
        this.isShipToNoValid()
    );
  }

  isShipToNoValid(): boolean {
    return Boolean(this.shippingAddressShipToNo.valid && this.isShipToNoUnique());
  }

  isShipToNoUnique(): boolean {
    const foundShippingAddress: KrampShippingAddress | undefined = this.shippingAddresses.find(s => {
      if (this.createMode) {
        return s.shipToNo === this.workingShippingAddress.shipToNo;
      } else {
        return s.shipToNo === this.workingShippingAddress.shipToNo && s.id != this.workingShippingAddress.id;
      }
    });
    if (foundShippingAddress) {
    }
    return foundShippingAddress == undefined;
  }

  isCustomerIdValid(): boolean {
    if (!this.viewInitialized) {
      return false;
    }
    return Boolean(this.shippingAddressCustomerId.valid && this.isCustomeridUnique());
  }

  isCustomeridUnique(): boolean {
    const foundShippingAddress: KrampShippingAddress | undefined = this.shippingAddresses.find(s => {
      if (this.createMode) {
        return s.customerId === this.workingShippingAddress.customerId;
      } else {
        return s.customerId === this.workingShippingAddress.customerId && s.id != this.workingShippingAddress.id;
      }
    });
    return foundShippingAddress == undefined;
  }

  onCustomerNumberChange(customerNumber: string): void {
    if (!this.createMode) {
      return;
    }

    if (this.shippingAddressShipToNo.dirty) {
      return;
    }

    const digits = (customerNumber || '').replace(/\D/g, '');

    if (!digits) {
      this.workingShippingAddress.shipToNo = '';
      return;
    }

    if (digits.startsWith('000')) {
      const last5 = digits.slice(-5);
      this.workingShippingAddress.shipToNo = '9' + last5;
    } else {
      const last6 = digits.slice(-6);
      this.workingShippingAddress.shipToNo = last6;
    }
  }

  isShipToNoNormConform(): boolean {
    const shipTo = this.workingShippingAddress.shipToNo;
    const customerId = this.workingShippingAddress.customerId;

    if (!shipTo) {
      return true;
    }

    const shipToDigits = shipTo.replace(/\D/g, '');
    const customerDigits = customerId.replace(/\D/g, '');

    if (!customerDigits) {
      return true;
    }

    let expected: string;

    if (customerDigits.startsWith('000')) {
      const last5 = customerDigits.slice(-5);
      expected = '9' + last5;
    } else {
      expected = customerDigits.slice(-6);
    }

    return shipToDigits === expected;
  }
}
